import React from 'react';
import AppLoginActivityCards from './AppLoginActivityCards';
import './AppLoginActivity.css';

const AppLoginActivity: React.FC = () => {
  return (
    <div className="app-login-activity-page">
      <AppLoginActivityCards />
    </div>
  );
};

export default AppLoginActivity;
